import { IStatisticsGrid } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidPpPlayerStatisticsQuery } from './typeguards';
import { CreatePlayerPagesStatsInputSchema, PlayerPagesStatsSeasonCompStat } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { PlayerStatisticsQuery } from '../types';

import { playerGoalkeeperOrderStats, playerMovementOrderStats, playerGoalkeeperOrderChart, playerMovementOrderChart } from '../../../utils/player';

export default (obj: PlayerStatisticsQuery):IStatisticsGrid => {
  
  if (isValidPpPlayerStatisticsQuery(obj)) {
    CreatePlayerPagesStatsInputSchema().parse(obj.data.getPlayerPagesStats, { reportInput: true });

    
    const { playerId, playerRole, statistics } = obj.data.getPlayerPagesStats;
    const firstStatistic = statistics?.[0] as PlayerPagesStatsSeasonCompStat;

    const isGoalKeeper = playerRole === 'Goalkeeper';

    const dropdown = {
      text: firstStatistic?.customCompetitionName ?? '',
      links: statistics?.map((stat, index) => ({ label: stat?.customCompetitionName ?? '', isSelected: index === 0 })) ?? [],
      showSelected: true,
      menuSize: 'medium' as 'medium',
    };

    const subtitle = `STAGIONE ${firstStatistic?.customSeasonName ?? ''}`;

    const statisticsMapped = statistics?.map((stat) => {

      const { seasonAndCompId, customSeasonName, customCompetitionName, stats, charts } = stat as PlayerPagesStatsSeasonCompStat;
      
      const orderedStat = isGoalKeeper ? playerGoalkeeperOrderStats : playerMovementOrderStats;
      const orderedChart = isGoalKeeper ? playerGoalkeeperOrderChart : playerMovementOrderChart;

      const filteredStats = stats?.filter((stat: any) => orderedStat.includes(stat.type)).sort((a: any, b: any) => orderedStat.indexOf(a.type) - orderedStat.indexOf(b.type));
      
      charts?.sort((a: any, b: any) => orderedChart.indexOf(a.type) - orderedChart.indexOf(b.type));

      const mappedStats = filteredStats?.map((stat: any) => ({
        type: 'stat' as 'stat',
        id: stat.type,
        value: stat.value,
      }));

      const mappedCharts = charts?.map((chart: any) => ({
        id: chart.type,
        success: chart.success,
        failure: chart.failure,
      })) ?? [];

      const allItems = [
        ...(mappedStats?.slice(0, isGoalKeeper ? 4 : 8) ?? []),
        { type: 'chart' as 'chart', charts: mappedCharts },
        ...(mappedStats?.slice(isGoalKeeper ? -4 : -6) ?? []),
      ];

      return { 
        seasonAndCompId: seasonAndCompId ?? '', 
        customSeasonName: customSeasonName ?? '', 
        customCompetitionName: customCompetitionName ?? '', 
        items: allItems 
      };
    }) ?? [];

    const payload = {
      dropdown,
      subtitle,
      statisticsMap: statisticsMapped,
      statistics: {
        playerId,
        playerRole: playerRole as any,
        items: statisticsMapped?.[0]?.items ?? [],
      },
    } as IStatisticsGrid;

    return payload;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in PpPlayerStatisticsQuery object',
      data: obj,
    });
  }
};
